import { useAPI } from '../../../clients/quipli-service/quipli-service-client';
import { useEffect, useState } from 'react';
import { Typography } from '../../../components/typography/typography';
import { Field } from '../../../components/field/field';
import { Button } from '../../../components/form/button';
import { useNavigate } from 'react-router-dom';
import { usePaymentConfigApiV1 } from '../../../clients/quipli-service/payment-config/payment-config-api-v1';

export const StripeAccountSetup = () => {
  const [businessName, setBusinessName] = useState<string>('');
  const [businessEmail, setBusinessEmail] = useState<string>('');
  const [country, setCountry] = useState<string>('');
  const navigate = useNavigate();

  const { getMultipleConfigurations, getCountry } = useAPI();
  const { addStripeAccount } = usePaymentConfigApiV1();
  useEffect(() => {
    Promise.all([getMultipleConfigurations(['CONF_WEBSITE_NAME', 'CONF_STRIPE_ACCOUNT_TYPE']), getCountry()]).then(
      ([confs, country]) => {
        confs.filter((c) => c.variable === 'CONF_WEBSITE_NAME').forEach((c) => setBusinessName(c.value));
        setCountry(country.code);
      },
    );
  }, []);

  const onSubmit = async () => {
    const adminContext = window.location.pathname.substring(0, window.location.pathname.indexOf('/manager'));
    const newAccount = await addStripeAccount({ businessEmail, businessName, userId: 1 });
    if (newAccount.accountType === 'custom' && country == 'US') {
      navigate(`${adminContext}/manager/quipli-pay/customConnectOnboarding/${newAccount.stripeAccountId}`);
    } else {
      navigate(`${adminContext}/manager/quipli-pay`);
    }
  };

  return (
    <div>
      <div className={'section-head'}>
        <Typography type={'display-md'}>Payment Account Setup</Typography>
      </div>
      <div>
        <Field
          type={'text'}
          label={'Business Name'}
          value={businessName}
          onChange={(value) => {
            setBusinessName(value);
          }}
        />
      </div>
      <div>
        <Field
          type={'text'}
          label={'Business Email'}
          value={businessEmail}
          onChange={(value) => {
            setBusinessEmail(value);
          }}
        />
      </div>
      <Button className={'button-primary'} onClick={() => onSubmit()}>
        Create Payment Account
      </Button>
    </div>
  );
};
